import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';
import { PrimeReactProvider, PrimeReactContext } from 'primereact/api';
import "primereact/resources/themes/lara-light-cyan/theme.css";
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render( <PrimeReactProvider><App/></PrimeReactProvider>);